import styled from "styled-components";

export const MainSideBarWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
    user-select: none;
`

export const MenuWrapper = styled.div`
    flex: 1 1 auto;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
`;

export const MenuItemWrapper = styled.div`
    display: flex;
    flex-direction: column; 
    align-items: center; 
    justify-content: center;
    text-align: center; 
    height: 100%;
    padding: 0px 30px;
`;

export const MenuIcon = styled.div`  
    display: flex;
    align-items: center; 

    & .anticon {
        font-size: 30px;
    }
`;


export const MenuItemText = styled.div`
    font-size: 12px;
    margin-top: 6px;
    letter-spacing: 2px;
    color: #000000;
    line-height: 150%;

    &.active {
        font-weight: bold;
        color: #4290f7;
    }
`;

